import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductosApiService } from 'src/app/service/api/productos-api';
import { DashboardService } from 'src/app/service/events/dashboard.service';
import { BaseForm } from 'src/app/view/base-form';
import { ProductosGanaderiaFormDefinition } from '../form-control/productos-ganaderia-form-definition';

import { ProductosModel } from 'src/app/models/productos/productos.model';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-producto-ganaderia-form',
    standalone: false,
    templateUrl: './producto-ganaderia-form.component.html',
    styleUrls: ['./producto-ganaderia-form.component.scss']
})
export class ProductoGanaderiaFormComponent extends BaseForm<ProductosModel> implements OnInit {

    public override model: ProductosModel = {nombre: '', materia_activa: ''};
    public form!: ProductosGanaderiaFormDefinition;
    public reactiveFormRecordId = '';

    public nameModule = environment.features.nameModuloGanaderia;

    constructor(
        public override route: ActivatedRoute,
        public dashboardEvents: DashboardService,
        public productApi: ProductosApiService,
        public override router: Router,
    ) {
        super(
            route,
            router,
            dashboardEvents,
            productApi.productos.PUT,
            productApi.productos.POST,
            'productos-ganaderia',
            'Actualizar producto de '.concat(environment.features.nameModuloGanaderia),
            'Crear producto de '.concat(environment.features.nameModuloGanaderia)
        );
    }

    public ngOnInit(): void {
        this.softInit(this.getType());
        this.model = this.initializeHostModel({ ...this.model, ...this.getModel() });
        this.reactiveFormRecordId = this.resolveReactiveFormRecordId(this.model);
        this.form = new ProductosGanaderiaFormDefinition(this.getType(), this.model);
    }

}
